import { render, staticRenderFns } from "./ProductContentAccordian.vue?vue&type=template&id=14b9fd79&scoped=true"
import script from "./ProductContentAccordian.vue?vue&type=script&lang=js"
export * from "./ProductContentAccordian.vue?vue&type=script&lang=js"
import style0 from "./ProductContentAccordian.vue?vue&type=style&index=0&id=14b9fd79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9fd79",
  null
  
)

export default component.exports